export default __webpack_public_path__ + "static/media/jti-white.ac705536.svg";